import router from "@/router";
import fileModule from "@/store/modules/file.module";
import { Component, Vue } from "vue-property-decorator";
import AuthService from '@/shared/services/auth.service';
import { itiTokenService } from '@/iti-core-vue';
import { itiHttpService } from './../../iti-core-vue/services/iti-http-service';

const auth = new AuthService();

@Component({
  components: {

  }
})
export default class AuthCallbackComponent extends Vue {

  public created() {
    //console.log("AuthCallbackComponent create");
  }

  public async mounted() {
    auth.getUser().then(async (user) => {
      //console.log(user);
      if (user) {
        itiTokenService.setToken(user.access_token);
        itiHttpService.updateHeader();
      }
      let returnUrl = sessionStorage.getItem('loginReturnURL');
      if (returnUrl != null && returnUrl.length > 0) {
        let e = null;
        let fileToShow = sessionStorage.getItem('fileToShow');
        if (fileToShow != null && fileToShow.length > 1) {
          e = JSON.parse(fileToShow);
          await fileModule.setFileToShow(e);
        }
        sessionStorage.removeItem('loginReturnURL');
        sessionStorage.removeItem('fileToShow');
        this.$router.push({ name: returnUrl, params: { collaborativeAreaId: e.ambitId } });
      } else {
        router.push('/main');
      }
    }).catch(() => {
        router.push('/main');
    });

  }
}
